/* @flow */
import Entity from 'lib/Entity';
import MessageDeliverySummary from 'entities/MessageDeliverySummary';

export default class MessageDelivery extends Entity {
  initialize() {
    this.idAttribute = 'message_uuid';
  }

  parse(response: Object) {
    if (response['read_summary']) {
      response['read_summary'] = new MessageDeliverySummary(response['read_summary']);
    }

    return response;
  }

  setReadSummaryState(state: LegacyMessageDeliveryStatusType) {
    this.getReadSummary().setState(state);
  }

  getReadSummary(): MessageDeliverySummary {
    return this.get('read_summary');
  }
}
